module.exports = __webpack_public_path__ + "static/img/28.fd7fb6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/image/28.jpg
// module id = Egis
// module chunks = 0